import request from '@/utils/request'

// 服务项目列表
export const listServiceItem = (pageData, formData) => {
    return request.get(`/serviceItem/page/${pageData.page}/${pageData.pageSize}`, {params: formData})
}
// 新增服务项目
export const addServiceItem = (formData) => {
    return request.post('/serviceItem', formData)
}
// 服务项目详情
export const listServiceItemDetail = (id) => {
    return request.get(`/serviceItem/${id}`)
}

// 修改服务项目
export const editServiceItem = (updateData) => {
    return request.put('/serviceItem', updateData)
}

// 删除服务项目
export const deleteServiceItem = (id) => {
    return request.delete(`/serviceItem/${id}`)
}